import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { JobsService as CmbJobsApi } from '@bluecrew/crew-member-backend-angular-client';
import { SegmentCMOSService } from './segment-cmos.service';

@Injectable({
  providedIn: 'root',
})
export class PendingJobConfirmationsService {
  private readonly PENDING_JOB_CONFIRMATION_STORAGE_KEY =
    'pendingJobConfirmations';

  constructor(
    private readonly storage: Storage,
    private readonly cmbJobsApi: CmbJobsApi,
    private readonly segmentCMOS: SegmentCMOSService
  ) {}

  public async getPendingConfirmations(
    checkRecentTransitions: boolean = true
  ) {
    try {
      const { pendingJobConfirmations, cooldownSettings } =
        await this.cmbJobsApi.getPendingJobConfirmations().toPromise();
      const pendingJobConfirmationsFromStorage =
        await this.getPendingJobConfirmationsFromStorage();
      // remove keys not present in request from storage
      const activePendingJobConfirmations = pendingJobConfirmations
        .map((pendingJobConfirmation) => pendingJobConfirmation.externalPingId)
        .reduce((agg, pingId) => {
          agg[pingId] = pendingJobConfirmationsFromStorage[pingId];
          return agg;
        }, {});
      await this.storePendingJobConfirmations(
          activePendingJobConfirmations
      );
      const now = Date.now();
      return pendingJobConfirmations
          .filter(pendingJobConfirmation => {
            const lastViewed = activePendingJobConfirmations[pendingJobConfirmation.externalPingId];
            return !checkRecentTransitions ||
                   !lastViewed ||
                   lastViewed + cooldownSettings.milliseconds < now
          });
    } catch (err) {
      await this.segmentCMOS.addEvent('pending_job_confirmation_failed', {
        reason: err?.error?.reason,
        message: err?.message,
      });
    }
    return [];
  }

  public async viewedPendingConfirmation(pingId: string){
    const pendingJobConfirmationsFromStorage = await this.getPendingJobConfirmationsFromStorage();
    await this.storePendingJobConfirmations({...pendingJobConfirmationsFromStorage,[pingId]:Date.now()})
  }

  private async getPendingJobConfirmationsFromStorage() {
    const storageValue = await this.storage.get(
      this.PENDING_JOB_CONFIRMATION_STORAGE_KEY
    );
    return (storageValue || {}) as PendingJobConfirmationStorage;
  }

  private async storePendingJobConfirmations(
    pendingJobConfirmationsFromStorage: PendingJobConfirmationStorage
  ) {
    await this.storage.set(
      this.PENDING_JOB_CONFIRMATION_STORAGE_KEY,
      pendingJobConfirmationsFromStorage
    );
  }
}

type PendingJobConfirmationStorage = { [pingId: string]: number };
